import React, { useEffect, useState } from "react";
import { authApi } from "@/api";
import { useAuthStore } from "@/stores/authStore";
import { FALLBACK_PHOTO, FALLBACK_QUOTE, greeting } from "./loginContent";

export default function Login() {
  const setAuth = useAuthStore((s) => s.setAuth);
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState(() => { try { return JSON.parse(sessionStorage.getItem("login_content") || "null"); } catch { return null; } });
  useEffect(() => { authApi.loginContent().then((c) => { setContent(c); sessionStorage.setItem("login_content", JSON.stringify(c)); }).catch(() => {}); }, []);
  const photo = content?.photo || FALLBACK_PHOTO;
  const quote = content?.quote || FALLBACK_QUOTE;
  const doLogin = async (username, password) => {
    setLoading(true); setError("");
    try { const r = await authApi.login(username, password); setAuth(r.access_token, r.user); }
    catch (err) { setError(err.response?.data?.detail || "Přihlášení se nezdařilo"); }
    finally { setLoading(false); }
  };
  const submit = (e) => { e.preventDefault(); doLogin(form.username, form.password); };
  return (
    <div className="flex min-h-screen flex-col bg-gray-50 lg:flex-row" data-testid="login-page">
      <section className="relative h-64 w-full overflow-hidden bg-gray-900 sm:h-80 lg:h-auto lg:flex-1" data-testid="login-team-photo">
        <img src={photo.src} alt={photo.caption} className="absolute inset-0 h-full w-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-950/85 via-gray-900/25 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-6 text-white sm:p-10 lg:p-14">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/70">{photo.caption}</p>
          <p className="mt-3 max-w-2xl text-xl font-semibold leading-snug sm:text-2xl lg:text-3xl" data-testid="login-quote">„{quote.text}“</p>
          {quote.by && <p className="mt-2 text-sm text-white/70">— {quote.by}</p>}
        </div>
      </section>
      <section className="flex w-full items-center justify-center px-6 py-10 lg:w-[460px] lg:px-12">
        <form onSubmit={submit} className="w-full max-w-sm">
          <p className="text-sm font-medium text-brand-700">{greeting()}, týme 👋</p>
          <h1 className="mt-1 text-2xl font-semibold text-gray-900">CRM <span className="text-brand-600">Machna</span> <span className="text-sm font-normal text-gray-400">v2</span></h1>
          <p className="mt-1 text-sm text-gray-500">Přihlaste se a jdeme na to.</p>
          <label className="mt-8 block text-sm font-medium text-gray-600">E-mail (stejný jako v původní Machně)</label>
          <input data-testid="login-username" autoFocus autoComplete="username" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} className="mt-1 w-full rounded-md border border-gray-200 bg-white px-3 py-2.5 text-base outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-100" />
          <label className="mt-4 block text-sm font-medium text-gray-600">Heslo</label>
          <input data-testid="login-password" type="password" autoComplete="current-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1 w-full rounded-md border border-gray-200 bg-white px-3 py-2.5 text-base outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-100" />
          {error && <p className="mt-3 text-sm text-red-600" data-testid="login-error">{error}</p>}
          <button data-testid="login-submit" disabled={loading} className="mt-6 w-full rounded-md bg-brand-600 py-2.5 text-base font-medium text-white hover:bg-brand-700 disabled:opacity-50">{loading ? "Přihlašuji…" : "Přihlásit se"}</button>
        </form>
      </section>
    </div>
  );
}
